export default "__VITE_ASSET__Dh61lWpR__"